import Block from './Block.vue';

export default Block;



// WEBPACK FOOTER //
// ./src/pages/profile/views/career-guidance/components/block/index.ts